export class IOSSender {
  send(event) {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      if (!window.webkit) {
        throw new Error('iOS message handler could not be found');
      }
      window.webkit.messageHandlers[event.type].postMessage(typeof event.detail === 'undefined' || event.detail === null ? '' : event.detail);
    } catch (_unused) {
      throw new Error('Could not send event to host application');
    }
  }
}
//# sourceMappingURL=IOSSender.js.map